import { defineMessage } from 'services/localization';

export const messages = {
    warningText: defineMessage('please_note_that_paymen__amount_due_of_the_bill'),
};
